import {
  SAVE_BLOCKED_JOINS_INCOMPLETE,
  SAVE_BLOCKED_NAME_MISSING,
  SAVE_BLOCKED_NAME_NOT_UNIQUE,
  SAVE_BLOCKED_NO_COLUMNS,
} from "../types/constants";
import { Typography } from "@mui/material";
import * as labels from "config.labels";
import React from "react";
import * as staticDataHooks from "store/hooks/staticDataHooks";

const MESSAGES = {
  [SAVE_BLOCKED_NO_COLUMNS]: {
    key: labels.REPORT_BUILDER_BLOCKED_NO_COLUMNS,
    default: "No columns selected",
  },
  [SAVE_BLOCKED_JOINS_INCOMPLETE]: {
    key: labels.REPORT_BUILDER_BLOCKED_JOINS_INCOMPLETE,
    default: "Joins incomplete",
  },
  [SAVE_BLOCKED_NAME_MISSING]: {
    key: labels.REPORT_BUILDER_BLOCKED_NAME_MISSING,
    default: "Name missing",
  },
  [SAVE_BLOCKED_NAME_NOT_UNIQUE]: {
    key: labels.REPORT_BUILDER_BLOCKED_NAME_NOT_UNIQUE,
    default: "Cannot create: Name is not unique",
  },
};

// Says why the Save and Create buttons are disabled, and renders nothing when
// neither of them is blocked by the specification.
const SaveBlockedMessage = ({ reason }) => {
  const translateLabels = staticDataHooks.useTranslator("uiLabels");
  const message = MESSAGES[reason];
  if (!message) return null;
  return (
    <Typography
      variant={"body2"}
      color={"text.secondary"}
      sx={{ alignSelf: "center", mr: 1 }}
    >
      {translateLabels(message.key, { default: message.default })}
    </Typography>
  );
};

export default SaveBlockedMessage;
